import { OriginType } from './origin-type.enum';
import { State } from './state';
import { HomeRiskData } from './home-risk-data';
import { CarRiskData } from './car-risk-data';
import { PersonalsAccidentsRiskData } from './personals-accidents-risk-data';
import { IntegralRiskData } from './integral-risk-data.model';
import { CarQuote } from './car-quote.model';

export class Opportunity {
    age: number;
    automaticAdjustment: number;
    branch: string;
    branchOffice: number;
    commercialAlternative: number;
    created: string;
    documentNumber: string;
    email: string;
    isRead: boolean;
    lastUpdated: string;
    name: string;
    opportunitiesId: number;
    phoneAreaCode: number;
    phoneNumber: number;
    postalCode: number;
    producerCuit: string;
    producerName: string;
    producerCode: string;
    riskData: PersonalsAccidentsRiskData | HomeRiskData | CarRiskData | IntegralRiskData;
    salesforceLeadId: number;
    sourceId?: OriginType;
    subSourceId?: string;
    state: State;
    organizerNumber?: number;
    comment?: string;
    cityName?: string;
    cityKey?: string;
    stateKey?: string;
    clientFirstName?: string;
    clientLastName?: string;
    quotes?: Array<CarQuote>;
}

